import service from "@/store/services/resellers-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  reseller: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, reseller) => {
    state.reseller = reseller;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((reseller) => {
      commit("SET_RESOURCE", reseller);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((reseller) => {
      commit("SET_RESOURCE", reseller);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((reseller) => {
      commit("SET_RESOURCE", reseller);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  generateAccessToken({ commit, dispatch }, params) {
    return service.generateAccessToken(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  reseller: (state) => state.reseller,
  url: (state) => state.url,
};

const resellers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default resellers;
